import { alpha } from '@mui/material/styles';

export const CHAT_LIBRARY_PAGE_TITLE_SX = {
  fontSize: 22,
  fontWeight: 700,
  lineHeight: '28px',
  letterSpacing: '-0.02em',
  color: 'text.primary',
};

export const CHAT_LIBRARY_COUNT_SX = {
  fontSize: 12,
  fontWeight: 500,
  lineHeight: '16px',
  color: 'text.secondary',
};

export const CHAT_LIBRARY_HEADER_SX = {
  display: 'flex',
  alignItems: { xs: 'flex-start', sm: 'center' },
  justifyContent: 'space-between',
  gap: 2,
  flexWrap: 'wrap',
};

export const CHAT_LIBRARY_HEADER_ACTIONS_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.25,
  flexWrap: 'wrap',
  justifyContent: { xs: 'stretch', sm: 'flex-end' },
  width: { xs: '100%', sm: 'auto' },
};

export const CHAT_LIBRARY_SEARCH_SX = {
  width: { xs: '100%', sm: 280 },
  flex: { xs: '1 1 100%', sm: '0 0 auto' },
  '& .MuiOutlinedInput-root': {
    minHeight: 36,
    fontSize: 13,
    borderRadius: '8px',
  },
  '& .MuiOutlinedInput-input': {
    py: '7px',
    px: 0.5,
  },
};

export const CHAT_LIBRARY_TOOLBAR_SX = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1.5,
  flexWrap: 'wrap',
  minHeight: 36,
};

export const CHAT_LIBRARY_SORT_SX = {
  minWidth: 148,
  '& .MuiOutlinedInput-root': {
    minHeight: 32,
    fontSize: 12.5,
    borderRadius: '8px',
  },
  '& .MuiSelect-select': {
    py: '5px',
    px: 1.25,
  },
};

export const CHAT_LIBRARY_LIST_HEADER_SX = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
  px: 0.25,
  pb: 1,
  mb: 0.5,
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const CHAT_LIBRARY_LIST_HEADER_LABEL_SX = {
  fontSize: 11,
  fontWeight: 600,
  lineHeight: '14px',
  color: 'text.secondary',
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
};

export function chatLibraryRowSx(theme, { selected = false } = {}) {
  const isDark = theme.palette.mode === 'dark';
  const hoverBg = isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)';

  return {
    width: '100%',
    minWidth: 0,
    minHeight: 64,
    px: 1.25,
    py: 1.5,
    display: 'flex',
    alignItems: 'center',
    gap: 3,
    textAlign: 'left',
    boxSizing: 'border-box',
    cursor: 'pointer',
    border: 0,
    borderRadius: 1,
    bgcolor: selected
      ? alpha(theme.palette.primary.main, isDark ? 0.14 : 0.06)
      : 'transparent',
    '&:hover': {
      bgcolor: selected
        ? alpha(theme.palette.primary.main, isDark ? 0.18 : 0.08)
        : hoverBg,
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: -2,
    },
  };
}

export const CHAT_LIBRARY_ROW_MAIN_SX = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
};

export const CHAT_LIBRARY_ROW_TITLE_SX = {
  width: '100%',
  fontSize: 14,
  fontWeight: 600,
  lineHeight: '20px',
  color: 'text.primary',
};

export const CHAT_LIBRARY_ROW_PREVIEW_SX = {
  width: '100%',
  fontSize: 13,
  fontWeight: 400,
  lineHeight: '18px',
  color: 'text.secondary',
};

export const CHAT_LIBRARY_ROW_DATE_SX = {
  flexShrink: 0,
  minWidth: 148,
  fontSize: 12,
  fontWeight: 500,
  lineHeight: '16px',
  color: 'text.secondary',
  whiteSpace: 'nowrap',
  textAlign: 'right',
};

export const CHAT_LIBRARY_EMPTY_SX = {
  textAlign: 'center',
  py: { xs: 6, md: 8 },
};

export const CHAT_LIBRARY_EMPTY_TITLE_SX = {
  fontSize: 16,
  fontWeight: 700,
  lineHeight: '22px',
  color: 'text.primary',
};

export const CHAT_LIBRARY_EMPTY_BODY_SX = {
  mt: 0.75,
  fontSize: 13,
  lineHeight: '18px',
  color: 'text.secondary',
};
